module.exports = __webpack_public_path__ + "static/jade10-d328381627769bc867d48413eea115b4.png";